import { useState } from "react";

import {
  makeGetApiCall,
  makePostApiCall,
  makePutApiCall,
} from "../../../shared/makeApiCall";
import ClassDetailsForm from "../../../components/forms/setup/classes/ClassDetailsForm";
import { createSnackbarHelpers } from "../../../shared/snackbar";
import DeleteConfirmationForm from "../../../components/forms/DeleteConfirmationForm";

export function ClassesViewModel(logout, addSnackbar) {
  const [loading, setLoading] = useState(false);
  const [classes, setClasses] = useState({
    data: [],
  });
  const [slideOver, setSlideOver] = useState({
    childComponent: null,
    open: false,
  });
  const [emptyModal, setEmptyModelOpen] = useState({
    open: false,
    childComponent: null,
  });
  const [allergenOptions, setAllergenOptions] = useState([]);
  const [specSheetTestOptions, setSpecSheetTestOptions] = useState([]);

  const { showSuccess } = createSnackbarHelpers(addSnackbar);

  const getClasses = async function (search, page) {
    setLoading(true);

    let callResult = await makePostApiCall(
      `classes?page=${page}&search=${search}`
    );
    setLoading(false);
    if (callResult.success) {
      setClasses(callResult.data);
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
    }
  };

  const createClass = async function (values) {
    const payload = { ...values };
    let callResult = await makePostApiCall("classes/create", payload);

    if (callResult.success) {
      showSuccess("Class added");
      setSlideOver({
        childComponent: null,
        open: false,
      });
      setTimeout(function () {
        getClasses("", 1);
      }, 1000);
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
    }
  };

  const updateClass = async function (values, index) {
    let callResult = await makePutApiCall(`classes/${values.id}`, values);

    if (callResult.success) {
      showSuccess("Class updated");
      setSlideOver({
        childComponent: null,
        open: false,
      });

      getClasses("", 1);
      // const currentItems = [...classes.data];
      // var payload = {
      //   index: index,
      //   item: callResult.data.item,
      // };
      // const newItems = updateObjectInArray(currentItems, payload);
      // setClasses({ ...classes, data: newItems });
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
    }
  };

  const openAddClassSlideOver = (isEdit, item, index) => {
    setSlideOver({
      childComponent: (
        <ClassDetailsForm
          item={item}
          isEdit={isEdit}
          setOpen={setSlideOver}
          specSheetTestOptions={specSheetTestOptions}
          allergenOptions={allergenOptions}
          actionCall={(payload) =>
            isEdit ? updateClass(payload, index) : createClass(payload)
          }
          title={isEdit ? `Update ${item.name}` : "Add new class"}
        />
      ),
      open: true,
    });
  };

  const deleteClass = async function (id, index) {
    setLoading(true);

    let callResult = await makePostApiCall(`deleteClass/${id}`);
    setLoading(false);
    if (callResult.success) {
      setEmptyModelOpen({
        open: false,
        childComponent: null,
      });

      const newItems = classes.data.filter((item) => item.id !== id);
      setClasses({ ...classes, data: newItems });

      showSuccess(callResult.data.message);
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
    }
  };

  const askDeleteClass = function (item, index) {
    setEmptyModelOpen({
      childComponent: (
        <DeleteConfirmationForm
          buttonMessage="Delete"
          confirmAction={() => deleteClass(item.id, index)}
          message={`Are you sure you want to delete  ${item.name}?`}
          setOpen={setEmptyModelOpen}
          hideReason={true}
        />
      ),
      open: true,
    });
  };

  const getSpecSheetTestsForDropdown = async function () {
    let callResult = await makeGetApiCall("specSheetTestsForDropdown");
    if (callResult.success) {
      setSpecSheetTestOptions(callResult.data);
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
    }
  };

  const getAllergens = async function () {
    let callResult = await makeGetApiCall("allergensForDropdown");
    if (callResult.success) {
      setAllergenOptions(callResult.data);
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
    }
  };

  return {
    openAddClassSlideOver,
    getClasses,
    loading,
    classes,
    setSlideOver,
    slideOver,
    setEmptyModelOpen,
    emptyModal,
    askDeleteClass,
    getSpecSheetTestsForDropdown,
    getAllergens,
  };
}
